const statistic = {
  namespaced: true,
  state: {
    data: null
  },
  getters: {
    getStatistic: state => {
      return state.data
    }
  },
  mutations: {
    setStatistic: (state, statistic) => {
      state.data = statistic
    }
  },
  actions: {

  }

}

export default statistic
